import { render, staticRenderFns } from "./advancedEditingBtn.vue?vue&type=template&id=58f876c2&scoped=true&"
import script from "./advancedEditingBtn.vue?vue&type=script&lang=js&"
export * from "./advancedEditingBtn.vue?vue&type=script&lang=js&"
import style0 from "./advancedEditingBtn.vue?vue&type=style&index=0&id=58f876c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f876c2",
  null
  
)

export default component.exports